export default {
  title: 'Trigger message on Offer fulfillment',
  description: 'Send a triggered marketing message to a member when this offer is fulfilled',
};
